import React from 'react'

import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import SurveyPendampingan from 'app/KinerjaKSPage/pages/Pelaksanaan/SurveyPendampingan/SurveyPendampingan'
import PageGuardKs from 'app/KinerjaKSPage/components/PageGuardKs'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (_: NextPageContext, toggle: TToggleKeyValuePair) => {
    const isKinerjaKsEnabled = toggle['kinerja-ks-enabled'] || false
    const isKinerjaKsPelaksanaanEnabled =
      toggle['kinerja-ks-pelaksanaan-enabled'] || false
    const isEnabled = isKinerjaKsEnabled && isKinerjaKsPelaksanaanEnabled

    if (!isEnabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }
  },
})

const SurveyPendampinganPage = () => (
  <PageGuardKs>
    <SurveyPendampingan />
  </PageGuardKs>
)

SurveyPendampinganPage.Layout = KinerjaLayout

SurveyPendampinganPage.layoutOpts = {
  hasHeader: true,
  centered: true,
}

export default SurveyPendampinganPage
